import { gql } from '@apollo/client';
import { apolloClient } from '../apollo/client';

export type TipoAtor = 'SISTEMA' | 'USUARIO' | 'WEBHOOK';

export interface Historico {
  id: string;
  textoRenderizado?: string | null;
  atorId?: string | null;
  tipoAtor: TipoAtor;
  refs?: any | null;
  torneioId?: string | null;
  categoriaTorneioId?: string | null;
  data: string;
}

export interface HistoricoConnection {
  nodes: Historico[];
  totalCount: number;
}

export const HISTORICO_POR_ID = gql`
  query HistoricoPorId($id: ID!) {
    historico(id: $id) {
      id
      textoRenderizado
      atorId
      tipoAtor
      refs
      torneioId
      categoriaTorneioId
      data
    }
  }
`;

export interface HistoricoPorIdVars {
  id: string;
}

export interface HistoricoPorIdData {
  historico: Historico | null;
}

export const LISTAR_HISTORICOS = gql`
  query ListarHistoricos {
    historicos {
      nodes {
        id
        textoRenderizado
        atorId
        tipoAtor
        refs
        torneioId
        categoriaTorneioId
        data
      }
      totalCount
    }
  }
`;

export interface ListarHistoricosVars {}

export interface ListarHistoricosData {
  historicos: HistoricoConnection;
}

export const HISTORICOS_POR_ATOR = gql`
  query HistoricosPorAtor($atorId: ID!) {
    historicosPorAtor(atorId: $atorId) {
      nodes {
        id
        textoRenderizado
        atorId
        tipoAtor
        refs
        torneioId
        categoriaTorneioId
        data
      }
      totalCount
    }
  }
`;

export interface HistoricosPorAtorVars {
  atorId: string;
}

export interface HistoricosPorAtorData {
  historicosPorAtor: HistoricoConnection;
}

export const HISTORICO_POR_TORNEIO = gql`
  query HistoricoPorTorneio($torneioId: ID!) {
    historicoPorTorneio(torneioId: $torneioId) {
      nodes {
        id
        textoRenderizado
        atorId
        tipoAtor
        refs
        torneioId
        categoriaTorneioId
        data
      }
      totalCount
    }
  }
`;

export interface HistoricoPorTorneioVars {
  torneioId: string;
}

export interface HistoricoPorTorneioData {
  historicoPorTorneio: HistoricoConnection;
}

export const HISTORICO_POR_CATEGORIA_TORNEIO = gql`
  query HistoricoPorCategoriaTorneio($categoriaTorneioId: ID!) {
    historicoPorCategoriaTorneio(categoriaTorneioId: $categoriaTorneioId) {
      nodes {
        id
        textoRenderizado
        atorId
        tipoAtor
        refs
        torneioId
        categoriaTorneioId
        data
      }
      totalCount
    }
  }
`;

export interface HistoricoPorCategoriaTorneioVars {
  categoriaTorneioId: string;
}

export interface HistoricoPorCategoriaTorneioData {
  historicoPorCategoriaTorneio: HistoricoConnection;
}

export const historicoPorId = async (id: string): Promise<Historico | null> => {
  const { data } = await apolloClient.query<HistoricoPorIdData, HistoricoPorIdVars>({
    query: HISTORICO_POR_ID,
    variables: { id },
    fetchPolicy: 'no-cache',
  });
  return data.historico;
};

export const listarHistoricos = async (): Promise<HistoricoConnection> => {
  const { data } = await apolloClient.query<ListarHistoricosData, ListarHistoricosVars>({
    query: LISTAR_HISTORICOS,
    variables: {},
    fetchPolicy: 'no-cache',
  });
  return data.historicos;
};

export const historicosPorAtor = async (atorId: string): Promise<HistoricoConnection> => {
  const { data } = await apolloClient.query<HistoricosPorAtorData, HistoricosPorAtorVars>({
    query: HISTORICOS_POR_ATOR,
    variables: { atorId },
    fetchPolicy: 'no-cache',
  });
  return data.historicosPorAtor;
};

export const historicoPorTorneio = async (torneioId: string): Promise<HistoricoConnection> => {
  const { data } = await apolloClient.query<HistoricoPorTorneioData, HistoricoPorTorneioVars>({
    query: HISTORICO_POR_TORNEIO,
    variables: { torneioId },
    fetchPolicy: 'no-cache',
  });
  return data.historicoPorTorneio;
};

export const historicoPorCategoriaTorneio = async (
  categoriaTorneioId: string
): Promise<HistoricoConnection> => {
  const { data } = await apolloClient.query<
    HistoricoPorCategoriaTorneioData,
    HistoricoPorCategoriaTorneioVars
  >({
    query: HISTORICO_POR_CATEGORIA_TORNEIO,
    variables: { categoriaTorneioId },
    fetchPolicy: 'no-cache',
  });
  return data.historicoPorCategoriaTorneio;
};

